<div class="dialog-container">
    <div class="title" mat-dialog-title>
        {{data.title | translate}}
        <img class="close-icon" (click)="close()" src="assets/close-icon.png" />
    </div>
    <mat-divider></mat-divider>

    <div class="my-3">
        <mat-dialog-content [ngClass]="{'country-restriction-content': data?.isCountryRestriction}">
            @if (data?.isCountryRestriction) {
                <svg class="warning-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.13939 1.95114C7.5267 1.29754 8.47277 1.29754 8.86009 1.95114L15.1052 12.4892C15.5002 13.1558 15.0197 13.999 14.2449 13.999H1.75462C0.980043 13.9987 0.499467 13.1557 0.894271 12.4892L7.13939 1.95114ZM7.99974 9.99899C7.44761 9.99913 6.99979 10.4468 6.99974 10.999C6.99974 11.5512 7.44758 11.9988 7.99974 11.999C8.55202 11.999 8.99974 11.5513 8.99974 10.999C8.99969 10.4467 8.55199 9.99899 7.99974 9.99899ZM7.56615 5.49899C7.26552 5.49913 7.03276 5.76314 7.07005 6.06149L7.44505 9.06149C7.47647 9.31144 7.68921 9.49886 7.94115 9.49899H8.05833C8.31035 9.49899 8.52297 9.31149 8.55443 9.06149L8.92943 6.06149C8.96673 5.76306 8.73408 5.49899 8.43333 5.49899H7.56615Z" fill="#ED8B00"/>
                </svg>
                <div class="description-wrapper">
                    <span class="description" *ngIf="data.description">
                        <span *ngIf="data.projectName">{{data.projectName}} </span>{{data.description | translate}}
                    </span>
                </div>
            } @else {
                <span class="description" *ngIf="data.description">
                    <span *ngIf="data.projectName">{{data.projectName}} </span>{{data.description | translate}}
                </span>
            }
                <div *ngIf="data.description1 && data.description2">
                    <span class="description">{{data.description1 | translate}}</span>
                    <br><br>
                    <span class="description">{{data.description2 | translate}}</span>
                </div>
           
        </mat-dialog-content>
    </div>

    <mat-divider></mat-divider>
    
    @if (data?.isCountryRestriction) {
        <div class="button-container">
            <mat-dialog-actions>
                <button class="mat-raised-button" (click)="saveasDraft()">{{data.seconadarybutton | translate}}</button>
                <button class="mat-raised-button mat-primary ms-3 country-restriction-btn" (click)="save()">
                    {{data.primarybutton | translate}}
                </button>
            </mat-dialog-actions>
        </div>
    } @else {
        <div class="float-end">
            <mat-dialog-actions>
                <button class="mat-raised-button" (click)="saveasDraft()">{{data.seconadarybutton | translate}}</button>
                <button class="mat-raised-button mat-primary ms-3" (click)="save()">{{data.primarybutton | translate}}</button>
            </mat-dialog-actions>
        </div>
    }

</div>